 import { Input } from '../../Components/UI/Input/Input';
 import { CheckBox } from '../../Components/UI/Input/CheckBox';
import classes from './Reg.module.css'
import { MouseEvent, useState } from 'react';
import Button1 from '../../Components/UI/Button1/Button1';
import Select from '../../Components/UI/Select/Select';
import { log } from 'console';
import { data, Link, useNavigate } from 'react-router-dom';
import { IRegForm, IRegFormError } from '../../Intarfaces/IReg';
import RegAPI from '../../API/RegAPI';
import FullSpaseLoader from '../../Components/UI/Loader/FullSpaseLoader';
import educationPlaseholder from '../../helpers/educationPlaseholder';
 

const minData = new Date(new Date(new Date().setFullYear(new Date().getFullYear()-35)).toISOString().split("T")[0]+"T00:00:00")
const maxData = new Date(new Date(new Date().setFullYear(new Date().getFullYear()-14)).toISOString().split("T")[0]+"T00:00:00") 
const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const regexPhone = /^(\+7|8)[\s\-]?\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{2}[\s\-]?\d{2}$/;

 const Reg = () => {


    const [form, setForm]  = useState({
        full_name:'',
        birthday:'',
        status:'',
        organization:'',
        education:'',
        education_name:'',
        email:'',
        phone:'',
        soglasie:'',
    } as IRegForm)
    const [formError, setFormError] = useState({
    } as IRegFormError) 

    const [isSendFormLoader, setIsSendFormLoader] = useState(false)

    const setValue = (properte:string, value:string) =>{
        setForm({...form,[properte]:value})
    }

    const validate = (formV:IRegForm):IRegFormError =>{
          
        const formErrorV = {} as IRegFormError
        formErrorV.countError = 0
        for(let keyI in formV){
            
            switch (keyI){
                case "full_name":
                    if(formV[keyI].length===0){
                        formErrorV.full_name = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    else if(formV[keyI].replace(" ",'').length<2){
                        formErrorV.full_name = "Некорректные данные"
                        formErrorV.countError++
                    }
                    break;
                case "birthday":
                    if(formV[keyI].length===0){
                        formErrorV.birthday = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    else if(!(new Date(formV[keyI]+'T00:00:00').getTime()>=minData.getTime() && new Date(formV[keyI]+'T00:00:00').getTime()<=maxData.getTime())){
                        formErrorV.birthday = "Возраст участника должен быть от 18 до 35 лет"
                        formErrorV.countError++
                    }
                    break;
                case "status":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.status = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    break;
                case "organization":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.organization = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    break;
                case "education":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.education = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    break;
                case "education_name":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.education_name = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    break;
                case "email":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.email = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    else if(!regexEmail.test(formV[keyI])){
                        formErrorV.email = "Некоректный E-mail"
                        formErrorV.countError++
                    }
                    break;
                case "phone":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.phone = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    else if(!regexPhone.test(formV[keyI])){
                        formErrorV.phone = "Некоректный номер телефона"
                        formErrorV.countError++
                    }
                    break;
                case "soglasie":
                    if(formV[keyI]!=="true"){
                        formErrorV.globalError  = "Требуется дать согласие на обработку данных"
                        formErrorV.countError++
                    }
                    break; 
            }

        }
        

        return formErrorV

    }

    const nav = useNavigate()

    const sendForm = async (e:MouseEvent<HTMLButtonElement>) =>{
        e.preventDefault()
        const error = validate(form)
        setFormError(error)

        if(error.countError!==0){
            return;
        }

        setIsSendFormLoader(true)
        const response = await RegAPI.reg(form)
        setIsSendFormLoader(false)

        setFormError({...formError, globalError:null})

        if(response.status!==200){
            setFormError({...formError, globalError: response.message})
            return;
        }

        nav('/regresult')
        


    }

    return ( 
        <div className={classes.reg}>
            <div className={classes.container}>
                <div style={{minHeight:"50px"}}/>
                <div className={classes.formName}>
                    Создать аккаунт
                </div>
                <form>
                    <div className={classes.inputs}>
                        <div className={classes.input}>
                            <Input placeholder='ФИО' value={form.full_name} onChange={(e)=>setValue('full_name', e.target.value)}/>
                            <div className={classes.error}>
                                {formError.full_name}
                            </div>
                        </div>
                        <div className={classes.input}>
                            
                            <Input type={form.birthday.length===0?"text":"date"} 
                            min={minData.toISOString().split("T")[0]} max={maxData.toISOString().split("T")[0]} 
                            onFocus={(e)=>e.target.type='date'}  placeholder='Дата рождения' 
                            value={form.birthday} onChange={(e)=>setValue('birthday', e.target.value)}/>
                            <div className={classes.error}>
                                {formError.birthday}
                            </div>
                        </div>
                        
                        <div className={classes.input}>
                            <Select onChange={(e)=>setValue('status', e.target.value)}>
                                <option value="">--Статус--</option>
                                <option value="студент">Студент</option>
                                <option value="аспирант">Аспирант</option>
                                <option value="сотрудник">Сотрудник</option>
                            </Select>
                            <div className={classes.error}>
                                {formError.status}
                            </div>
                        </div>
                        <div className={classes.input}>
                            <Input placeholder='Наименование организации' value={form.organization} onChange={(e)=>setValue('organization', e.target.value)}/>
                            <div className={classes.error}>
                                {formError.organization}
                            </div>
                        </div>
                        <div className={classes.input}>
                            <Select onChange={(e)=>setValue('education', e.target.value)}>
                                <option value="">--Профиль обучения--</option>
                                <option value="факультет">Факультет</option>
                                <option value="институт">Институт</option>
                                <option value="высшая школа">Высшая школа</option>
                                <option value="вертикаль">Вертикаль</option>
                            </Select>
                            <div className={classes.error}>
                                {formError.education}
                            </div>
                        </div>
                        {
                            form.education!==""?
                            <div className={classes.input}>
                                <Input placeholder={educationPlaseholder(form.education)} value={form.education_name} onChange={(e)=>setValue('education_name', e.target.value)}/>
                                <div className={classes.error}>
                                    {formError.education_name}
                                </div>
                            </div>
                            :
                            <></>

                        }
                        <div className={classes.input}>
                            <Input type='email' placeholder='E-mail' value={form.email} onChange={(e)=>setValue('email', e.target.value)}/>
                            <div className={classes.error}>
                                {formError.email}
                            </div>
                        </div>
                        
                        <div className={classes.input}>
                            <Input placeholder='Номер телефона' value={form.phone} onChange={(e)=>setValue('phone', e.target.value)}/>
                            <div className={classes.error}>
                                {formError.phone}
                            </div>
                        </div>
                        {/* <div className={classes.input}>
                            <Input placeholder='Город'/>
                        </div> */}
                    </div>
                    <div className={classes.input}>
                        <div className={classes.soglasie}>
                            <CheckBox name='soglasie' id='soglasie' onChange={(e)=>setValue('soglasie',e.target.checked.toString())}/>
                            <label htmlFor='soglasie'>
                                <a target='_blank' href='/soglasie'>Согласие на обработку персональных данных</a>
                            </label>
                        </div>  
                        <div className={classes.error}>
                            {formError.globalError}
                        </div>
                    </div>
                    <Button1 onClick={(e)=>sendForm(e)} style={{marginTop:"15px"}}>
                        Зарегистрироваться
                    </Button1>

                    <div className={classes.linkAuth}>
                        Уже есть аккаунт? <Link to='/auth'>Войти</Link>
                    </div>                  

                </form>
                <div style={{minHeight:"90px"}}/>
            </div>
            <FullSpaseLoader text='Отправка' isLoader={isSendFormLoader}/>

        </div>
     );
 }
  
 export default Reg;